// extracted by mini-css-extract-plugin
export default {"heroImg":"HeroBanner_heroImg__uVfM6"};